import { useToastsStore } from "@/store/toasts";

export const useCopyToClipboard = () => {

    const toastsStore = useToastsStore();

    const copy2clipboard = (what2copy) => {

        navigator.clipboard.writeText(what2copy).then(() => {
            console.log('📋 copied to clipboard');
            toastsStore.toast({
                title: 'Appunti',
                text: 'Copiato negli appunti',
                // type: 'success',
                // duration: 50000
            })
        })
    }

    return {
        copy2clipboard,
    };
}


export default useCopyToClipboard
